
import { Options, Vue } from "vue-class-component";
import Header from "@/components/Header.vue";
import ExerciseModule from "@/components/ExerciseModule.vue";
import ApiService from "../services/ApiService";
import StorageService from "@/services/StorageService";
import { useStore } from "vuex";
import { wrapper } from "../utils/wrapper";
import { closePage, openPage } from "@/utils/patientLoggerPage";

@Options({
  components: {
    Header,
    ExerciseModule
  }
})
export default class Exercises extends Vue {
  viewName = "Exercises";
  patientLoggerPageId: number | undefined;
  private storageService = new StorageService();
  private apiService = new ApiService();
  globalStore = useStore();
  user: any = null;
  language: any = null;
  treatmentSet = false;
  treatmentId: any = null;
  modules: any = [];

  async created() {
    this.user = this.storageService.getUser();
    this.language = this.user.language;
    await this.getTreatment();
    await this.getModules();
  }

  async mounted() {
    this.patientLoggerPageId = await openPage(
      this.viewName,
      this.user.patientsId
    );
  }

  async beforeUnmount() {
    if (this.patientLoggerPageId && this.storageService.getUser()) {
      await closePage(this.patientLoggerPageId, this.user.patientsId);
    }
  }

  async getTreatment() {
    const dataResponse = await wrapper(
      this.apiService.getTreatment(this.user.patientsId)
    );
    if (dataResponse.error) {
      console.error("get modules error ", dataResponse.error);
      this.globalStore.commit("open", {
        type: "danger",
        title: this.$t("ALERTS.MODULES.GET_TREATMENT.FAILED.TITLE"),
        text: this.$t("ALERTS.MODULES.GET_TREATMENT.FAILED.TEXT")
      });
    }

    if (dataResponse.data) {
      if (Object.entries(dataResponse.data).length === 0) {
        this.treatmentSet = false;
      } else {
        this.treatmentSet = true;
        this.treatmentId = dataResponse.data.id;
      }
    }
  }

  async getModules() {
    if (this.treatmentId) {
      const dataResponse = await wrapper(
        this.apiService.getModules(this.user.patientsId, this.treatmentId)
      );
      if (dataResponse.error) {
        console.log(dataResponse.error);
        console.error("get current module error ", dataResponse.error.data);
        this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.MODULES.GET.FAILED.TITLE"),
          text: this.$t("ALERTS.MODULES.GET.FAILED.TEXT")
        });
      }

      if (dataResponse.data) {
        this.treatmentSet = true;

        // sort modules by order
        dataResponse.data.sort((moduleA: any, moduleB: any) => {
          return (
            moduleA.treatmentsModules.order - moduleB.treatmentsModules.order
          );
        });

        for (const rawMod of dataResponse.data) {
          const mod = {
            ...rawMod,
            started: rawMod.modulesStates[0].started
          };

          await this.getModule(mod);
          await this.getPageElements(mod);

          this.modules.push(mod);
        }
      }
    }
  }

  async getModule(mod: any) {
    if (mod.id) {
      const dataResponse = await wrapper(
        this.apiService.getModule(this.user.patientsId, mod.id)
      );
      if (dataResponse.error) {
        console.error("get module error ", dataResponse.error.data);
        this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.MODULES.GET_CURRENT_MODULE.FAILED.TITLE"),
          text: this.$t("ALERTS.MODULES.GET_CURRENT_MODULE.FAILED.TEXT")
        });
      }

      if (dataResponse.data && dataResponse.data.pages) {
        mod.pages = dataResponse.data.pages;
      }
    }
  }

  async getPageElements(mod: any) {
    if (mod.pages) {
      for (const page of mod.pages) {
        const dataResponse = await wrapper(
          this.apiService.getPageElements(this.user.patientsId, page.id)
        );
        if (dataResponse.error) {
          console.error("get page elements error ", dataResponse.error.data);
          this.globalStore.commit("open", {
            type: "danger",
            title: this.$t("ALERTS.MODULES.GET.FAILED.TITLE"),
            text: this.$t("ALERTS.MODULES.GET.FAILED.TEXT")
          });
        }
        page.pageElements = dataResponse.data.pagesElements;
        if (dataResponse.data.pagesElements[0]?.templatesId) {
          page.templateElements =
            dataResponse.data.pagesElements[0].templates.templatesElements;
        }
      }
    }
  }
}
